// extracted by mini-css-extract-plugin
export default {"button":"styles_button__n7CTi","outlinedButton":"styles_outlinedButton__32Tv3","disable":"styles_disable__RSc4P","remove":"styles_remove__T14T0"};